import { render } from "./Courts.vue?vue&type=template&id=215a3d53"
import script from "./Courts.vue?vue&type=script&lang=js"
export * from "./Courts.vue?vue&type=script&lang=js"

import "./Courts.vue?vue&type=style&index=0&id=215a3d53&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__